import React, { useCallback, useEffect, useState } from 'react';
import { imageList } from './DataLists';
import { FaApple, FaGooglePlay } from "react-icons/fa";
import { ReactComponent as MobileLogo } from '../assets/mobiles.svg';
import { FormModal } from './FormModal';
import { createClient } from '@supabase/supabase-js';
import { UserCounter } from './UserCounter';
import Countdown from './Countdown';
import { SurveyModal } from './SurveyModal';

const supabase = createClient(
  "https://rgbpcypagbxucucbairq.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJnYnBjeXBhZ2J4dWN1Y2JhaXJxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA5MzgzNTMsImV4cCI6MjA1NjUxNDM1M30.Rsh4BSZBqTRQZrFu2btVKCmcNcRXdBoN3zV4CjbB-OQ"
);

type User = {
  id: number;
  email: string;
};

function FirstSection() {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [registeredUsers, setRegisteredUsers] = useState<User[]>([]);
  const [stickToTop, setStickToTop] = useState(false);
  const [showSurvey, setShowSurvey] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const pageHeight = document.body.offsetHeight;

      setStickToTop(scrollPosition >= pageHeight - 50);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  const getRegisteredUser = useCallback(async () => {
    const { data, error } = await supabase.from('pre-registration').select('*');
    if (error) {
      console.error('Error fetching users:', error);
      return [];
    }
    return data;
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      const users = await getRegisteredUser();
      setRegisteredUsers(users);
    };
    fetchUsers();
  }, [getRegisteredUser]);

  return (
    <div className='w-full min-h-screen flex flex-col md:flex-row bg-darkerBlue'>
      {/* Left section */}
      <div className='bg-primaryOrange w-full md:w-1/2 flex flex-col gap-10 py-10 md:py-0'>
        <div className='flex flex-col items-center md:items-start md:pl-14 px-4 md:px-0 space-y-7'>
          <h1 className='text-5xl md:text-7xl text-primaryWhite font-bold pt-5 text-center md:text-left'>Greetli</h1>

          <div className='flex flex-col items-center space-y-5 md:items-start w-full'>
            <p className='text-lighterOrange text-xl flex flex-col items-start text-center md:text-left'>
              Your immigration consultant in{' '}
              <span className='text-2xl text-primaryYellow font-semibold'>Switzerland</span>
            </p>

            <p className='text-lighterOrange text-xl w-full md:w-[70%] text-center md:text-left'>
              Find solutions for all aspects of relocation based on your origin and occupation. Get consultation from experts.
            </p>

            <div className='flex flex-wrap justify-center md:justify-start w-full md:w-[64%] items-center space-x-2 bg-darkOrange p-3 rounded-2xl'>
              {imageList.map((url, index) => (
                <img key={index} src={url} className='w-6 h-5' alt={`Image ${index + 1}`} />
              ))}
              <p className='text-lighterOrange text-xl'>Translated</p>
            </div>
          </div>
        </div>

        <div className={`fixed ${stickToTop ? 'top-2' : 'bottom-2'} left-1/2 -translate-x-1/2 z-50 transition-all duration-300 ease-in-out`}>
          <UserCounter userCount={registeredUsers.length} onClick={() => setShowModal(true)} />
        </div>

        <div className='w-full mt-auto bg-primaryOrange'>
          <Countdown />
          <img className='object-contain w-full h-auto' src={require('../assets/logo_wide.png')} alt='Logo' />
        </div>
      </div>

      {/* Right section with SVG and Survey button */}
      <div className='w-full md:w-1/2 flex flex-col items-center j space-y-6 px-6'>
        <div className='w-[90%] m:w-[600px]  lg:w-[650px]'>
          <MobileLogo className='w-full h-auto' />
        </div>

        <div className='mt-4 space-y-1 w-full max-w-[320px]'>
          <button
            onClick={() => setShowSurvey(true)}
            className='bg-primaryOrange hover:bg-primaryOrange/90 text-primaryWhite font-semibold py-5 rounded-xl shadow-lg transition duration-200 w-full'
          >
            🎯 Take a short survey & help us out
          </button>
          <div className='text-sm mt-8 text-white/70 text-center'>
            Powered by{' '}
            <a
              href='https://www.surveyconstructor.com'
              target='_blank'
              rel='noopener noreferrer'
              className='underline hover:text-white'
            >
              SurveyConstructor
            </a>
          </div>
        </div>
      </div>

      {/* Modals */}
      {showModal && <FormModal onClose={() => setShowModal(false)} />}
      {showSurvey && <SurveyModal onClose={() => setShowSurvey(false)} />}
    </div>
  );
}

export default FirstSection;